import { useContent } from '../../../../hooks/use-server-content';

export interface RecallsProps {
    hideContent?: boolean;
    title: string;
    recallsBannerSubtitle: string;
    recallsBannerDescription: string;
    recallsSubtitle: string;
    recallsDescription: string;
    scheduleServiceTitle: string;
    scheduleServiceDescription: string;
    findADealerButtonText: string;
    findADealerButtonLink: string;
    accordionTitle: string;
    accordionDescription: string;
    relatedTopicsTitle: string;
    relatedTopicsContent: string;

    vehicleSelectorVinSubtitle: string;
    vehicleSelectorVinInput: string;
    vinTooltipHeader: string;
    vinTooltipAriaLabel: string;
    vinTooltipContent: string;
    vehicleSelectorSubmitButtonLabel: string;
    vehicleSelectorDisclaimerLabel: string;
    vehicleSelectorDividerText: string;

    detailsVehicleLabel: string;
    hideVehicleLabelWithDetail?: boolean;
    detailsVinLabel: string;
    detailsEnterNewVin: string;
    detailsRecallsAccordionLabel: string;
    detailsRecallIncomplete: string;
    remedyNotAvailableLabel: string;
    detailsSafetyRiskLabel: string;
    detailsRemedyLabel: string;
    detailsRecallNumberLabel: string;
    detailsCspLabel: string;
    detailsAccordionChevronLabel: string;
    detailsNoCspLabel: string;
    detailsNoRecallsLabel: string;
    detailsCampaignNumberLabel: string;
    detailsAccordionDescriptionLabel: string;
    detailsIssueDateLabel: string;
    detailsNoCspShortLabel: string;
    detailsCspShortLabel: string;
    detailsMarketDisclaimer?: string;
    cspDisclaimer?: string;
    recallsAndCspWithRecallsDisclaimer: string;
    recallsAndCspWithCspDisclaimer: string;
    recallsAndNoCspWithRecallsDisclaimer: string;
    recallsAndNoCspWithCspDisclaimer: string;
    noRecallsAndCspWithRecallsDisclaimer: string;
    noRecallsAndCspWithCspDisclaimer: string;
    noRecallsAndNoCspWithRecallsDisclaimer: string;
    noRecallsAndNoCspWithCspDisclaimer: string;
    detailsAPIError: string;
    detailsNextStepsLabel: string;
    detailsNextStepsRecalls: string;
    detailsNextStepsCSP: string;
    preferredDealerButtonLabel: string;
    greenCheckMark: string;
    recallsDetailsAccordionTitle: string;
    campaignDetailsRecallTitle: string;
    campaignDetailsCspTitle: string;
    campaignDetailsErrorMessage: string;

    detailsNoRecallsDescription: string;
    detailsNoCspDescription: string;
    ymmRecallsMessage: string;
    ymmRecallsSubtitle: string;
    recallsLoadError: string;
    landingPageDisclaimer: string;
    recallsLastUpdatedText: string;
    recallsInformationUpToThisDateText: string;
}

export const useRecallsContent = (
    category = 'recalls',
    name = 'recalls'
): RecallsProps | null => {
    const [content, getValueByName] = useContent(category, name);
    let contentFragment: any = { recallsDescription: 'loading' };
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });

    if (content && contentFragment.recallsDescription !== 'loading') {
        if (contentFragment.hide || !contentFragment.title) {
            contentFragment = null;
        }
    }
    return contentFragment as RecallsProps;
};
